import Util from './util';

function add(type) {
    const
        triggerOpen = `.js--trigger-open-${type}`,
        triggerClose = `.js--trigger-close-${type}`,
        triggerToggle = `.js--trigger-toggle-${type}`,
        cls = `${type}_open`;

    $(document)
        .on('click', triggerOpen, (ev) => fixParent(getTriggeredEl(type, ev).addClass(cls), cls))
        .on('click', triggerClose, (ev) => fixParent(getTriggeredEl(type, ev).removeClass(cls), cls))
        .on('click', triggerToggle, (ev) => fixParent(getTriggeredEl(type, ev).toggleClass(cls), cls));
}

/**
 *
 * @param type
 * @param ev
 * @returns {JQuery<HTMLElement>}
 */
function getTriggeredEl(type, ev) {
    if(ev.target !== ev.currentTarget) return $('');
    const $trigger = $(ev.currentTarget);

    // get data-<type>-id attribute from clicked element
    let id = $trigger.data(type + '-id');

    // if clicked element has no data-<type>-id attribute, try to find a matching parent
    return id ? $(`.${type}[data-${type}-id="${id}"]`) : $trigger.closest('.' + type);
}

function fixParent($el, cls) {
    let $parent = $el.parent(),
        zIndex = Util.toInt($parent.css('z-index'));
    if($el.hasClass(cls)) {
        $parent.css('z-index', zIndex + 1);
    } else {
        $parent.css('z-index', '');
    }
}

export default {
    add
}